import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { MyWorkPage } from '@/features/my-work';
import { hasMyWork, sessionQuery } from '@/shared/auth';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/my-work')({
  validateSearch: z.object({ queue: zSearchText(), item: zSearchText(), q: zSearchText(), filter: zSearchText() }),
  staticData: { crumb: 'nav.myWork' },
  beforeLoad: async ({ context }) => {
    await requirePermission(context.queryClient, 'deal.view', 'My work');
    // People without shared queue work (sales, team leaders, managers) work from My deals; old bookmarks land there.
    const session = await context.queryClient.query({ ...sessionQuery, staleTime: 'static' });
    if (!hasMyWork(session)) throw redirect({ to: '/deals', search: { view: 'mine' } as never, replace: true });
  },
  component: function MyWork() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <MyWorkPage
        queue={search.queue}
        item={search.item}
        q={search.q}
        filter={search.filter}
        onChange={(patch, replace) =>
          void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: replace ?? false })
        }
      />
    );
  },
});
